import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { Switch, Route, useLocation } from 'react-router-dom';

import Layout from 'components/layout';
import Home from 'pages/home';
import Signin from 'pages/signIn';

import { ThemeProvider } from 'styled-components';
import GlobalStyles from 'components/common/GlobalStyles';
import theme from 'theme/theme';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <FramerRouter>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/signin">
          <Signin />
        </Route>
      </FramerRouter>
    </ThemeProvider>
  );
};

function FramerRouter({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <Layout>
        <Switch key={location.pathname} location={location}>
          {children}
        </Switch>
      </Layout>
    </AnimatePresence>
  );
}

export default App;
